import state from "./state";
import mutations from "./mutatios";

export default {
  state,
  mutations
};
